import React, {useState} from 'react';
import { useTranslation } from "react-i18next";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import { Grid } from "@mui/material";
import NotificationsTable from '../tables/notificationsTable';
import MDSnackbar from "components/MDSnackbar";


const ShowNotificationList = () => {
        const { t } = useTranslation();

        const [successSB, setSuccessSB] = useState(false);
        const [errorSB, setErrorSB] = useState(false);
        const openSuccessSB = () => setSuccessSB(true);
        const closeSuccessSB = () => setSuccessSB(false);
        const openErrorSB = () => setErrorSB(true);
        const closeErrorSB = () => setErrorSB(false);

        function bringSuccessNotification(){
            return (
                <MDSnackbar
                  color="success"
                  icon="check"
                  title={t("notifications.show.deleteSuccess.title")}
                  content={t("notifications.show.deleteSuccess.content")}
                  dateTime={new Date().toLocaleTimeString()}
                  open={successSB}
                  onClose={closeSuccessSB}
                  close={closeSuccessSB}
                  bgWhite
                />
              );
        }
    
        function bringErrorNotification(){  
            return (
                <MDSnackbar
                  color="error"
                  icon="warning"
                  title={t("notifications.show.deleteError.title")}
                  content={t("notifications.show.deleteError.content")}
                  dateTime={new Date().toLocaleTimeString()}
                  open={errorSB}
                  onClose={closeErrorSB}
                  close={closeErrorSB}
                  bgWhite
                />
              );
        }


    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                <Grid container item xs={12} md={12}>
                    <Grid container={true} p={2}>
                        <div className='rawContainerDiagrams'>
                            <div className='diagrammHeadTitle'>{t("notifications.show.heading")}</div>
                            <NotificationsTable setSuccessSB={setSuccessSB} setErrorSB={setErrorSB}  />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            {successSB && bringSuccessNotification()}
            {errorSB && bringErrorNotification()}
        </DashboardLayout>
    );
};

export default ShowNotificationList;